export const NETWORK_CATEGORIES = [
  'Alimentos y bebidas',
  'Belleza y cuidado personal',
  'Comercio y ventas',
  'Construcción y remodelación',
  'Consultoría y asesoría',
  'Diseño gráfico y creativo',
  'Educación y capacitación',
  'Electrónica y tecnología',
  'Entretenimiento y eventos',
  'Finanzas y contabilidad',
  'Fotografía y video',
  'Hogar y decoración',
  'Inmobiliaria',
  'Jardinería y paisajismo',
  'Legal y notaría',
  'Limpieza y mantenimiento',
  'Marketing y publicidad',
  'Mascotas',
  'Mecánica y automotores',
  'Medicina y salud',
  'Moda y ropa',
  'Música y artes',
  'Papelería e imprenta',
  'Restaurantes y catering',
  'Salud y bienestar',
  'Seguridad',
  'Servicios domésticos',
  'Transporte y logística',
  'Turismo y viajes',
  'Otro',
];

export const NETWORK_CATEGORY_OPTIONS = NETWORK_CATEGORIES.map((category) => ({
  key: category,
  value: category,
  text: category,
}));

export const isNetworkCategory = (value) => NETWORK_CATEGORIES.includes(value);
